/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![EyePlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACHElEQVR4nO1VPYsUQRA9P0A0UXMvEww8hEvUyFVEXdipejVIT9VoYKgmoomCyf4BFREj9Qd43oH/weUEA9FADXXhMPMbPxDFk+6dXWd2ZmfXvUiwoWCYqX6v6lX3m5mZ/2stq9FobARSItFFhnYZ+i2LLsPukWjknNswFTjF1gxAYqt1QWKvItGjf4O9jmDXcwDPme0Cke1xzm314Z8Jdp5Fn2V5vwh21e8dC85idwIw7KsHbrfb60cl+28+J8gW9uitWhKCXu5VpJ8j6OFJW2ZODpDYp6ywi9XgcbKfYD9Du6JR/hugsyy65EGIbHfV/gip+L0s9kMk3VtuFfY0q/7KMDjB3vZn0mw2N9UocDPkwR4XpI2QHu8NVF9HUbSl0L7oUv7UAHpwFIFzbjNBV0IuW/wHBPowIzhbqkp62g4C2vXzAU5ta8XJ3HA+kJ7OTt9yiYDFzowlkNwdgH0o5ZPbSbDvBH1Ulgi64tsckuj+yIsGXaiSitn2Mdv84IUfCIk+yYZ8o5jsdrHou3L1+iaOT+7IdbrM0E4V4YC1f0yZjYu66qz3Hhb9GAK6kAfvddojHkkQqoBe6l805uRQbfJwgZMQBB8SvZ0lf+HYztVZxTQEfZJr2a1cJdiL4Dds8/lLFjQf47S1MwGSY96Ki9as71utE9tDxdDOBFb+oLYV/zPxvkRid1nspXdNiu3IWiWaavG/TwDtVGn+G3VycuYXX2WTAAAAAElFTkSuQmCC)
 */
export const EyePlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.52 13.17c-.2.41-.87.35-1.15 0a3.02 3.02 0 0 0-.45-.48.47.47 0 0 1-.13-.54c.04-.1.04-.2-.01-.31-.4-.9-1.18-2.4-2.4-3.76C16.89 6.38 14.82 5 12 5 9.2 5 7.13 6.38 5.61 8.08a15.05 15.05 0 0 0-2.37 3.72.48.48 0 0 0 0 .4c.4.9 1.18 2.37 2.37 3.72a8.46 8.46 0 0 0 5.89 3.07c.28.01.5.24.54.5.05.31.15.6.29.87.13.27-.03.64-.33.64-7.11 0-10.27-7.11-10.89-8.7a.83.83 0 0 1 0-.6C1.73 10.1 4.9 3 12 3c7.11 0 10.27 7.11 10.89 8.7.07.2.07.4 0 .6-.08.21-.2.5-.37.87Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.56 11.77c.2-.1.44.02.44.23a4 4 0 1 1-4-4c.21 0 .33.25.23.44a2.5 2.5 0 0 0 3.32 3.32ZM19 14a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
